var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-6"},[_c('basic-question',{attrs:{"kind":"radio","title":"A asma prejudicou suas atividades no trabalho, na escola ou em casa?","questionData":{
      options: {
        'Nenhuma vez': 5,
        'Poucas vezes': 4,
        'Algumas vezes': 3,
        'Maioria das vezes': 2,
        'Todo o tempo': 1,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.blockedActivitiesRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "blockedActivitiesRate", $$v)},expression:"modelValue.blockedActivitiesRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Como está o controle da sua asma?","questionData":{
      options: {
        'Totalmente descontrolada': 1,
        'Pobremente controlada': 2,
        'Um pouco controlada': 3,
        'Bem controlada ': 4,
        'Completamente controlada': 5,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.lackOfAirRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "lackOfAirRate", $$v)},expression:"modelValue.lackOfAirRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Quantas vezes você teve falta de ar?","questionData":{
      options: {
        'De jeito nenhum': 5,
        'Uma ou duas vezes por semana ': 4,
        'Três a seis vezes por semana': 3,
        'Uma vez ao dia': 2,
        'Mais que uma vez ao dia': 1,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.nightAwakeningsRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "nightAwakeningsRate", $$v)},expression:"modelValue.nightAwakeningsRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"A asma acordou você à noite ou mais cedo que de costume?","questionData":{
      options: {
        'De jeito nenhum': 5,
        'Uma ou duas vezes': 4,
        'Uma vez por semana': 3,
        'Duas ou três noites por semana': 2,
        'Quatro ou mais noites por semana': 1,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.inhalorUsageRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "inhalorUsageRate", $$v)},expression:"modelValue.inhalorUsageRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Quantas vezes você usou o remédio por inalação para alívio?","questionData":{
      options: {
        'De jeito nenhum': 5,
        'Uma vez por semana ou menos': 4,
        'Poucas vezes por semana': 3,
        'Uma ou duas vezes por dia': 2,
        'Três ou mais vezes por dia ': 1,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.asthmaControl),callback:function ($$v) {_vm.$set(_vm.modelValue, "asthmaControl", $$v)},expression:"modelValue.asthmaControl"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }